import { SavedAnalysisPlanService } from './saved-analysis-plan.service';
import { FolderableCollectionLoadOnScrollServiceBase } from 'FoldersApp/services/folderable-collection-load-on-scroll-service-base.service';
import { formFlattenedObject } from 'Angular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "./saved-analysis-plan.service";
export class SavedAnalysisPlanFolderableCollectionListModalService extends FolderableCollectionLoadOnScrollServiceBase {
    get folderableCollection$() {
        if (this.dataParams === null)
            return null;
        const dataParams = formFlattenedObject(this.dataParams, Object.keys(this.dataParams));
        return this.savedAnalysisPlanService.getFolderableItemsListModal(dataParams);
    }
    constructor(savedAnalysisPlanService) {
        super();
        this.savedAnalysisPlanService = savedAnalysisPlanService;
        this.scrollableBodyId = 'analysisPlansModalTable';
    }
}
SavedAnalysisPlanFolderableCollectionListModalService.ɵfac = function SavedAnalysisPlanFolderableCollectionListModalService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SavedAnalysisPlanFolderableCollectionListModalService)(i0.ɵɵinject(i1.SavedAnalysisPlanService)); };
SavedAnalysisPlanFolderableCollectionListModalService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SavedAnalysisPlanFolderableCollectionListModalService, factory: SavedAnalysisPlanFolderableCollectionListModalService.ɵfac });
